// extracted by mini-css-extract-plugin
export default {"main":"video_main__IJZJE","temp":"video_temp__afLwM","video":"video_video__fsjG7","sentences":"video_sentences__vaECQ","animate1":"video_animate1__4-n9F"};